import {
    useGridApiContext,
    useGridSelector,
    gridPageSelector,
    gridPageCountSelector,
} from '@mui/x-data-grid-pro';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { Box } from '@mui/material';
import s from './GridPagination.module.scss'

function GridPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        apiRef!?.current!?.setPage(value - 1); // Pagination is 0-based internally
    };

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            px={2}
            sx={{
                padding: '14px 24px 18px 24px'
            }}
        >
            <button
                onClick={() => apiRef!?.current!?.setPage(Math.max(page - 1, 0))}
                disabled={page === 0}
                className={page === 0 ? `${s.paginationButton} ${s.paginationButton_disabled}` : s.paginationButton}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M15.8334 9.99996H4.16669M4.16669 9.99996L10 15.8333M4.16669 9.99996L10 4.16663"
                          stroke={page === 0 ? "#637882" : '#344054'}
                          strokeWidth="1.67"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                    />
                </svg>
                <span>Vorherige</span>
            </button>

            <Pagination
                count={pageCount}
                page={page + 1}
                onChange={handlePageChange}
                hidePrevButton={true}
                hideNextButton={true}
                renderItem={(item) => (
                    <PaginationItem
                        {...item}
                        sx={{
                            width: '40px',
                            height: '40px',
                            margin: 0,
                            borderRadius: '8px',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            color: '#667085',
                            '&.Mui-selected': {
                                color: '#3C8842',
                                backgroundColor: '#E7F0E8',
                            },
                            '&:hover': {
                                backgroundColor: '#E7F0E8',
                                color: '#3C8842',
                            },
                        }}
                    />
                )}
            />

            <button
                onClick={() => apiRef!?.current!?.setPage(Math.min(page + 1, pageCount - 1))}
                disabled={page >= pageCount - 1}
                className={page >= pageCount - 1 ? `${s.paginationButton} ${s.paginationButton_disabled}` : s.paginationButton}
            >
                <span>Nächste</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.16669 9.99996H15.8334M15.8334 9.99996L10 4.16663M15.8334 9.99996L10 15.8333"
                          stroke={page >= pageCount - 1 ? "#637882" : '#344054'}
                          strokeWidth="1.67"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                    />
                </svg>
            </button>
        </Box>
    );
}

export default GridPagination
